var radio_btn_group;

export default radio_btn_group = Vue.extend({
  props: {
    btn_group_options: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },

  data: function() {
    return {
      selected_value: this.btn_group_options[0]
    };
  },

  template: `
  <div class="radio-btns-group">
    <label v-for='(option, index) in btn_group_options'
           :key='index'
           @click="checkOption(option)"
           class="chart-radio-option" >
      <input :value="option"
             type="radio"
             class="chart-radio-input"
             hidden="hidden" />
      <span class="chart-radio-title" :class="[ selected_value == option ? 'active' : '' ]">{{ Skylark.Helpers.t('form.chart_type.' + option) }}</span>
    </label>
  </div>
  `,

  methods: {
    checkOption: function(option) {
      this.selected_value = option;
      return this.$emit('setSelectedValue', option);
    }
  }
});
